// stories-mock.ts — Stories strip data for HomePage.
// TODO(stories-api-PR): Replace with real GET /stories/featured.

const IMG = (id: string, w = 400) =>
  `https://images.unsplash.com/photo-${id}?w=${w}&q=80&auto=format&fit=crop`;

export interface Story {
  id: string;
  user: string;
  city: string;
  country: string;
  img: string;
  live: boolean;
  duration?: string; // e.g. "2h" — shown if not live
}

export const STORIES: Story[] = [
  {
    id: 's1',
    user: 'maya.j',
    city: 'Bali',
    country: 'Indonesia',
    img: IMG('1518548419970-58e3b4079ab2'),
    live: true,
  },
  {
    id: 's2',
    user: 'tomtravels',
    city: 'Tokyo',
    country: 'Japan',
    img: IMG('1480796927426-f609979314bd'),
    live: false,
    duration: '3h',
  },
  {
    id: 's3',
    user: 'rhea_w',
    city: 'Lisbon',
    country: 'Portugal',
    img: IMG('1513735492246-483525079686'),
    live: true,
  },
  {
    id: 's4',
    user: 'arjunk',
    city: 'Marrakech',
    country: 'Morocco',
    img: IMG('1545158539-1709bce6f5e3'),
    live: false,
    duration: '6h',
  },
  {
    id: 's5',
    user: 'leo.fly',
    city: 'Iceland',
    country: 'Iceland',
    img: IMG('1531366936337-7c912a4589a7'),
    live: false,
    duration: '1d',
  },
  {
    id: 's6',
    user: 'priya_s',
    city: 'Santorini',
    country: 'Greece',
    img: IMG('1570077188670-e3a8d69ac5ff'),
    live: true,
  },
];
